module.exports = __webpack_public_path__ + "img/moneybox.984c080a.svg";